module.exports = {
      id: "game-shop-usage",
      viewBox: "0 0 48.679 33.19",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#game-shop",
      toString: function () {
        return this.url;
      }
    }